// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.
import React, {Component} from 'react'

import './index.css'

export default class ConfirmationMessage extends Component {
  render () {
    return (
      <div className='confirmation-message'>
        <div className='inner-div row' onMouseDown={e => e.stopPropagation()}>
          <div className='message col-12'>
            {this.props.children || 'Are you sure you whant to continue?'}
          </div>
          <div className='buttons col-12'>
            <button className='btn btn-sm btn-accept col-5' onClick={this.props.onAccept}>{this.props.acceptButtonText || 'OK'}</button>
            <button className='btn btn-sm btn-cancel col-5' onClick={this.props.onCancel}>{this.props.cancelButtonText || 'Cancel'}</button>
          </div>
        </div>
      </div>
    )
  }
}

